import controller from './by-favorites.controller';
import templateBase from './templates/by-favorites-base.view.html';
import templateT15 from './templates/by-favorites-t15.view.html';
import templateAD from './templates/by-favorites-adaptative.html';

let ByFavoritesComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative) {
    return templateAD;
  } else {
    if (response.BY_FAVORITES.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default ByFavoritesComponent


// WEBPACK FOOTER //
// ./www/components/fast-purchase/by-favorites/by-favorites.component.js